/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ExitProcessError } from "@osdk/cli.common";
import { loadFoundryConfig } from "@osdk/foundry-config-json";
let siteConfigPromise = undefined;
let widgetSetConfigPromise = undefined;
function getConfig(type) {
  if (type === "site") {
    return getSiteConfig();
  } else {
    return getWidgetSetConfig();
  }
}
function getSiteConfig() {
  if (siteConfigPromise == null) {
    siteConfigPromise = loadFoundryConfig("site").catch(e => {
      throw new ExitProcessError(2, e instanceof Error ? e.message : undefined);
    });
  }
  return siteConfigPromise;
}
function getWidgetSetConfig() {
  if (widgetSetConfigPromise == null) {
    widgetSetConfigPromise = loadFoundryConfig("widgetSet").catch(e => {
      throw new ExitProcessError(2, e instanceof Error ? e.message : undefined);
    });
  }
  return widgetSetConfigPromise;
}
export default getConfig;